import { PropOptionSelect } from '@/models'

export const LOAN_STATUS_PENDING = 0
export const LOAN_STATUS_PAYED = 1

export const STATUS_OPTIONS: PropOptionSelect[] = [
  {
    value: LOAN_STATUS_PAYED,
    text: 'PAGADO'
  },
  {
    value: LOAN_STATUS_PENDING,
    text: 'PENDIENTE'
  }
]
